<ng-template #popContent>
  <div>
    <button
      *ngIf="showClose"
      (click)="p.close()"
      style="
        position: absolute;
        top: 5px;
        right: 5px;
        border: 0;
        background: none;
        font-weight: bold;
      "
    >
      x
    </button>
    <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
  </div>
</ng-template>

<div
  role="button"
  placement="bottom"
  [autoClose]="'outside'"
  [ngbPopover]="popContent"
  #p="ngbPopover"
  style="display: inline; margin-left: 20px"
>
  <ng-content></ng-content>
</div>
